class PopupSection extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.storageKey = `popup-section:${this.sectionId}`;
    this.editorKey = 'popup-section-selected';
    this.onClose = () => {
      this.rememberDismissal();
    };
    this.onSelect = (event) => {
      if (event.detail?.sectionId !== this.sectionId) return;
      this.writeEditorSelection(this.sectionId);
      this.open();
    };
    this.onDeselect = (event) => {
      if (event.detail?.sectionId !== this.sectionId) return;
      this.writeEditorSelection('');
      this.close();
    };

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:select', this.onSelect);
      document.addEventListener('shopify:section:deselect', this.onDeselect);
      if (this.readEditorSelection() === this.sectionId) this.open();
      return;
    }

    this.openOnLoad();
  }

  disconnectedCallback() {
    window.clearTimeout(this.openTimer);
    document.removeEventListener('shopify:section:select', this.onSelect);
    document.removeEventListener('shopify:section:deselect', this.onDeselect);
    this.dialogComponent?.removeEventListener('dialog:close', this.onClose);
  }

  openOnLoad() {
    const hasMessage = Boolean(this.querySelector('.email-signup__message'));
    const showAlways = this.dataset.display === 'always';
    const showOnce = this.dataset.display !== 'always' && !this.readDismissed();

    if (!hasMessage && !showAlways && !showOnce) return;

    const delay = hasMessage ? 0 : 400;
    this.openTimer = window.setTimeout(() => {
      this.open();
    }, delay);
  }

  async open() {
    await customElements.whenDefined('dialog-component');
    if (!this.isConnected) return;

    const dialogComponent = this.querySelector('dialog-component');
    if (!dialogComponent || typeof dialogComponent.showDialog !== 'function') return;

    if (this.dialogComponent !== dialogComponent) {
      this.dialogComponent?.removeEventListener('dialog:close', this.onClose);
      this.dialogComponent = dialogComponent;
      dialogComponent.addEventListener('dialog:close', this.onClose);
    }

    dialogComponent.showDialog();
  }

  close() {
    const dialogComponent = this.dialogComponent || this.querySelector('dialog-component');
    if (dialogComponent && typeof dialogComponent.closeDialog === 'function') {
      dialogComponent.closeDialog();
    }
  }

  rememberDismissal() {
    if (window.Shopify?.designMode || this.dataset.display === 'always') return;

    try {
      localStorage.setItem(this.storageKey, '1');
    } catch {
      return;
    }
  }

  readDismissed() {
    try {
      return localStorage.getItem(this.storageKey) === '1';
    } catch {
      return false;
    }
  }

  readEditorSelection() {
    try {
      return sessionStorage.getItem(this.editorKey) || '';
    } catch {
      return '';
    }
  }

  writeEditorSelection(sectionId) {
    try {
      if (sectionId) {
        sessionStorage.setItem(this.editorKey, sectionId);
      } else {
        sessionStorage.removeItem(this.editorKey);
      }
    } catch {
      return;
    }
  }
}

if (!customElements.get('popup-section')) {
  customElements.define('popup-section', PopupSection);
}
